<template>
  <el-tabs type="card" v-model="activeName">
    <el-tab-pane label="Product overview" name="first">
      <ProductOverview v-if="first"></ProductOverview>
    </el-tab-pane>
    <el-tab-pane label="New Active devices" name="second">
      <NewDecviceActive v-if="second"></NewDecviceActive>
    </el-tab-pane>
    <el-tab-pane label="Daily Active devices" name="third">
      <DailyActive v-if="third"></DailyActive>
    </el-tab-pane>
    <el-tab-pane label="Daily Online devices" name="fourth">
      <DailyOnline v-if="fourth"></DailyOnline>
    </el-tab-pane>
    <el-tab-pane label="Firmware version" name="fifth">
      <FirmwareVersion v-if="fifth"></FirmwareVersion>
    </el-tab-pane>
    <el-tab-pane label="Craftie statistical" name="sixth">
      <CraftiePlay v-if="sixth"></CraftiePlay>
    </el-tab-pane>
    <el-tab-pane label="Devices region distribution" name="seventh">
      <MapDecices v-if="seventh"></MapDecices>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import ProductOverview from './ProductOverview'
  import NewDecviceActive from './NewDecviceActive'
  import DailyActive from './DailyActive'
  import DailyOnline from './DailyOnline'
  import FirmwareVersion from './FirmwareVersion'
  import CraftiePlay from './CraftiePlay'
  import MapDecices from './MapDecvices'
  export default {
    name: 'index',
    components:{
      ProductOverview,NewDecviceActive,DailyActive,DailyOnline,FirmwareVersion,CraftiePlay,MapDecices
    },
    data(){
      return{
        activeName:'first',
        first: true,
        second:false,
        third:false,
        fourth:false,
        fifth:false,
        sixth:false,
        seventh:false
      }
    },
    methods:{
    },
    watch:{
      activeName:function (newData, oldData) {
        this[oldData]=false
        this[newData]=true
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/statistics/Statistics.vue